import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_srcglobal-web/artifacts/h90h1gk3_src-global-white.svg" 
                alt="SRC Global" 
                className="h-16 w-auto md:h-20"
                style={{ imageRendering: 'crisp-edges' }}
              />
            </div>
            <p className="text-gray-400 mb-6">
              Ihr Partner für nachhaltige Unternehmensentwicklung und CO₂-Kompensation.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-green-500" />
                <span>info@srcglobal.earth</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-green-500" />
                <span>044 722 32 35</span>
              </li>
              <li className="flex items-center space-x-3">
                <MapPin size={18} className="text-green-500" />
                <span>Chaltenbodenstrasse 26, 8834 Schindellegi</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} SRC Global. Alle Rechte vorbehalten.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/impressum-datenschutz" className="text-gray-400 hover:text-green-400 text-sm transition-colors">
              Datenschutz & Impressum
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;